import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "../initial-state";

const details = createSlice({
  name: "selectors",
  initialState: initialState.selectors,
  reducers: {
    setStake(state, action: PayloadAction<number>) {
      const value = action.payload;
      const index = state.stake.possibleValues.indexOf(value);
      const stake = { ...state.stake, value, index };

      return { ...state, stake };
    },

    initializeStake(
      state,
      action: PayloadAction<{ stakeValues: number[]; defaultBet: number }>
    ) {
      const { stakeValues, defaultBet } = action.payload;
      const value = stakeValues[defaultBet];
      const stake = { value, possibleValues: stakeValues, index: defaultBet };

      return { ...state, stake };
    },

    addToInfo(state, action: PayloadAction<{ value: string; text: string }>) {
      const old = state.info.possibleValues.find(
        ({ value, text }) =>
          action.payload.value === value && action.payload.text && text
      );
      // if the falue exist /old is not undefined/ the new value is added
      const newValue = old ? [] : action.payload;
      const possibleValues = state.info.possibleValues.concat(newValue);

      return { ...state, info: { ...state.info, possibleValues } };
    },

    removeFromInfo(state, action: PayloadAction<string>) {
      const possibleValues = state.info.possibleValues.filter(
        ({ value }) => value !== action.payload
      );

      return { ...state, info: { ...state.info, possibleValues } };
    },
  },
});

export const { setStake, initializeStake, addToInfo, removeFromInfo } =
  details.actions;

export default details;
